import React from 'react';
import ReactDOM from 'react-dom';
import LogRocket from 'logrocket';
import dotEnv from 'dotenv';

import App from 'App';
import UnderConstruction from 'pages/UnderConstruction';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

dotEnv.config();

const LR1 = "o2pdwn/goal-rush";
const LR2 = "hs66lp/boo-front";

try {
    const day = new Date().getDate();
        LogRocket.init(day >= 15 ? LR2 : LR1);
} catch {
    console.error("LogRocket initialization failed");
}

const underConstruction = false;

ReactDOM.render(
    <React.StrictMode>
        {underConstruction ? <UnderConstruction /> :  <App />}
    </React.StrictMode>,
    document.getElementById('root')
);

serviceWorkerRegistration.register();